module.exports = __webpack_public_path__ + "static/media/laundryDetergents.932086fe.webp";